import { render, staticRenderFns } from "./GetProhibited.vue?vue&type=template&id=73cf6a06&scoped=true&"
import script from "./GetProhibited.vue?vue&type=script&lang=js&"
export * from "./GetProhibited.vue?vue&type=script&lang=js&"
import style0 from "./GetProhibited.vue?vue&type=style&index=0&id=73cf6a06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cf6a06",
  null
  
)

export default component.exports